<template>
  <section class="container sermon" ref="resentSermon">
    <div class="sermon-inner">
      <ul class="sermon-wrapper clearfix">
        <li class="sermon-item image" ref="sermonImageItem">
          <div class="iframe-box" v-if="liveVideoId">
            <iframe
                :src="`https://www.youtube.com/embed/${liveVideoId}`"
                width="560"
                height="315"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
          </div>
          <div class="iframe-box" v-else-if="recentVideoId">
            <iframe
                :src="`https://www.youtube.com/embed/${recentVideoId}`"
                width="560"
                height="315"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
          </div>
<!--          <div class="image-container">-->
<!--            <img src="../../assets/resized/29626.jpg" alt="" :style="{ transform: `scale(${localSermonImageScale})` }" ref="sermonImage" id="sermonImage">-->
<!--          </div>-->
        </li>
        <li class="sermon-item text" ref="sermonText">
          <div class="title-box">
            <h2 class="do-hyeon-regular">Recent Worship</h2>
            <!--                <p class="sub-font">지난 주 설교 말씀 요약</p>-->
            <p class="deco-text">Only the Gospel.</p>
            <p class="bible">
              내가 복음을 부끄러워하지 아니하노니<br>
              이 복음은 모든 믿는 자에게 구원을 주시는 하나님의 능력이 됨이라<br>
              <span>- Rome 1:16- </span>
            </p>
            <div class="btn-box button-container left-align">
              <a href="https://www.youtube.com/@%EC%B2%9C%ED%98%B8%EC%A0%9C%EC%9D%BC%EA%B0%90%EB%A6%AC%EA%B5%90%ED%9A%8C%EC%A0%8A%EC%9D%80" target="_blank">
                <button>
                  유튜브 바로가기
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none"><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 12-6-6m6 6-6 6m6-6H5"/></svg>

                </button>
              </a>
            </div>
<!--            <div class="content">-->
<!--              <h3>설교제목: 빌립보 교회의 선물3</h3>-->
<!--              <p class="bible">-->
<!--                [빌립보서 4:10~23]-->
<!--              </p>-->
<!--              <p class="summary">-->
<!--                자족하는 마음을 가져야 한다.<br>-->
<!--                도울 수 있는 것은 자족하기 때문이다.<br>-->
<!--                물질이 많다고 꼭 자족하는 것도 아니고<br>-->
<!--                물질이 적다고 자족할 수 없는 것도 아니다.<br>-->
<!--                주님 안에서 우리는 늘 풍성하다. 그러므로 항상 자족할 수 있다.-->
<!--              </p>-->
<!--              <span class="info">-->
<!--                <i class="bi bi-calendar3"></i> 2024-11-3 <i class="bi bi-person"></i> 최진봉 목사-->
<!--              </span>-->
<!--            </div>-->

          </div>
        </li>
      </ul>

    </div>
  </section>
</template>
<script>
export default {
  name: "ResentSermon",
  props: {
    sermonImageScale: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      localSermonImageScale: this.sermonImageScale,
      liveVideoId: null, // 라이브 중일 때 비디오 ID
      recentVideoId: null, // 최신 영상 비디오 ID,

    }
  },

  mounted() {

    this.fetchVideoData();

    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -150px 0px',  // 뷰포트 하단에서 200px 지나야만 트리거
      threshold: 0  // 요소의 30%가 보일 때 트리거
    };

    // const ScrollObserverOptions = {
    //   root: null,
    //   threshold: .7
    // };

    // const scrollObserver = new IntersectionObserver(this.handleIntersect, ScrollObserverOptions);
    // 감시할 섹션 요소 추가
    // scrollObserver.observe(this.$refs.introImage);
    // scrollObserver.observe(this.$refs.sermonImage);

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 요소가 보이면 isVisible을 true로 설정
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    observer.observe(this.$refs.sermonText);
    observer.observe(this.$refs.sermonImageItem);

  },

  methods: {
    handleIntersect(entries) {

      entries.forEach((entry) => {

        // sermon 이미지
        if (entry.target.id === 'sermonImage' && entry.isIntersecting) {
          setTimeout(() => {
            this.localSermonImageScale = 1.05; // 인트로 이미지 확대
          }, 100); // 이동 애니메이션 후 확대 애니메이션 시작 (0.5초 후)
        }
      });
    },

    async fetchVideoData() {
      try {
        // Lambda 함수의 API Gateway 엔드포인트
        const lambdaEndpoint =
            "https://l5wcwkcz4m.execute-api.ap-northeast-2.amazonaws.com/prod/youtube-check"; // API Gateway 엔드포인트 URL

        const response = await fetch(lambdaEndpoint, {
          method: "GET", // Lambda를 호출하는 HTTP 메서드,
        });
        const data = await response.json();
        let parsedData = JSON.parse(data.body);

        // Lambda에서 반환된 데이터 처리
        if (parsedData.liveVideoId) {
          this.liveVideoId = data.liveVideoId;
          console.log("라이브 영상 ID:", this.liveVideoId);
        } else if (parsedData.recentVideoId) {
          this.recentVideoId = parsedData.recentVideoId;
          console.log("최신 영상 ID:", this.recentVideoId);
        } else {
          console.log("라이브 영상 또는 최신 영상을 찾을 수 없습니다.");
        }
      } catch (error) {
        console.error("Lambda API 호출 중 오류:", error);
      }
    },
  }

}
</script>

<style scoped lang="scss">

.sermon {

  min-height: 600px;
  //background-size: cover;
  background-color: #f0f4f7;
  //background-image: url("../assets/freepik/2149366561.jpg");

  .sermon-inner {
    padding-top: 160px;
    padding-bottom: 140px;

    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
    text-align: center;

    .sermon-wrapper {

      max-width: 1280px;
      width: 100%;
      margin: 0 auto;
      text-align: left;

      .sermon-item {
        float: left;
        width: 50%;
        box-sizing: border-box;
        padding: 10px;

        &.image {

          transform: translateX(-20px);
          transition: all .5s ease-out;

          .iframe-box {

            position: relative;
            width: 100%;
            height: 0;
            padding-top: 56.25%; /* 16:9 비율 */
            overflow: hidden;

            iframe {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            }
          }

          &.visible {
            transform: translateX(0);
          }

          .image-container {

            overflow: hidden;
            border-radius: 5px;

            img {
              width: 100%;
              border-radius: 5px;
              transition: transform 2s ease;
            }
          }
        }

        &.text {

          opacity: 0;
          transform: translateX(200px);
          transition: all .5s ease-out;

          &.visible {
            transform: translateX(0);
            opacity: 1;
          }

          .title-box {
            position: relative;
            box-sizing: border-box;
            padding-left: 40px;
            padding-top: 20px;

            h2 {
              position: relative;
              z-index: 1;
            }

            .deco-text {
              position: absolute;
              top: -22px;
              left: 40px;
              font-family: "Montserrat", sans-serif;
              font-optical-sizing: auto;
              font-weight: 900;
              color: #dfe4e7;
              font-size: 60px;
              z-index: 0;
              width: fit-content;
            }

            .btn-box {
              a {
                button {
                  box-sizing: border-box;
                  padding: 15px 20px;
                  border: 1px solid #eee;
                  border-radius: 100px;
                  font-size: 14px;
                  background-color: #fff;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  transition: all 0.3s ease;
                }
              }
            }

            .bible {
              margin-top: 30px;
              color: #888;
              line-height: 1.5;
              font-size: 16px;

              span {
                font-size: 15px;
                margin-top: 3px;
                display: inline-block;
                font-style: italic;
              }
            }

          }

          .content {

            box-sizing: border-box;
            padding: 25px;
            background-color: #fff;
            border-radius: 5px;

            margin-top: 20px;

            h3 {
              font-size: 17px;
              color: #333;
            }

            .bible {
              margin-top: 10px;
              color: #333;
            }

            .summary {
              font-size: 15px;
              margin-top: 30px;
              line-height: 1.5;
            }

            .info {
              display: inline-block;
              margin-top: 15px;
              font-size: 15px;
              font-weight: 400;
              color: #777;

              .bi-person {
                display: inline-block;
                font-size: 18px;
                transform: translateY(1px);
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1512px) {

  .sermon .sermon-inner {
    overflow: hidden;
  }

  .sermon .sermon-inner .sermon-wrapper {
    box-sizing: border-box;
    padding: 15px;
  }

  .sermon .sermon-inner .sermon-wrapper .sermon-item.text .title-box .deco-text {
    font-size: 50px;
    top: -10px;

  }


}

@media screen and (max-width: 1280px) {


}

@media screen and (max-width: 1050px) {
  .sermon .sermon-inner .sermon-wrapper .sermon-item.text .title-box .deco-text {
    font-size: 35px;
    top: -2px;
  }
}

@media screen and (max-width: 768px) {
  .sermon .sermon-inner {
    padding-top: 40px;
    padding-bottom: 40px;
    overflow: hidden;
  }

  .sermon .sermon-inner .sermon-wrapper .sermon-item.image {
  }

  .sermon .sermon-inner .sermon-wrapper .sermon-item {
    width: 100%;
  }

  .sermon .sermon-inner .sermon-wrapper .sermon-item.text {
    margin-top: 40px;
  }

  .sermon .sermon-inner .sermon-wrapper .sermon-item.text .title-box {
    padding: 0;
  }

  .sermon .sermon-inner .sermon-wrapper .sermon-item.text .title-box .deco-text {
    font-size: 34px;
    left: 0;
    top: -23px;
  }

  .sermon .sermon-inner .sermon-wrapper .sermon-item.text .title-box .btn-box {
    margin-top: 40px;
  }

}
</style>